import getConfig from "next/config";

import isSSR from "@/utils/is-ssr";

const { publicRuntimeConfig, serverRuntimeConfig } = getConfig();

const getServersideHopinRoot = (): string =>
  serverRuntimeConfig && serverRuntimeConfig.HOPIN_ROOT
    ? serverRuntimeConfig.HOPIN_ROOT
    : "https://events.ringcentral.com";

export const getClientsideApiRoot = (): string =>
  publicRuntimeConfig && publicRuntimeConfig.HOPIN_ROOT
    ? publicRuntimeConfig.HOPIN_ROOT
    : "https://events.ringcentral.com";

export default function getIsomorphicApiRoot(isServerside: boolean = isSSR) {
  return isServerside ? getServersideHopinRoot() : getClientsideApiRoot();
}
